import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DxButtonModule, DxPopupModule, DxToolbarModule} from "devextreme-angular";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {HistoryComponent, HistoryFilterData} from "../../history/history.component";
import {DxButtonTypes} from "devextreme-angular/ui/button";
import {UtilsService} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-popup-footer',
  standalone: true,
    imports: [CommonModule, DxButtonModule, DxPopupModule, DxToolbarModule, DxiItemModule, HistoryComponent],
  templateUrl: './popup-footer.component.html',
  styleUrls: ['./popup-footer.component.scss'],
})
export class PopupFooterComponent {
  @Input() formName!: string;
  @Input() historyEntityName!: string;
  @Input() historyEntityData!: HistoryFilterData;
  @Input() state!: string
  @Input() formAction!: string;
  @Input() errorResponse!: string[];
  @Output() showHistory = new EventEmitter<void>();
  historyPopupVisible=false


  toastMessageButtonOptions: DxButtonTypes.Properties = {
    icon: 'belloutline',
    stylingMode: 'outlined',
    hint: 'Hata Mesajları',
    onClick: () => {
      this.showLastErr(this.errorResponse)
    },
  };
  histyoryButtonOptions: DxButtonTypes.Properties = {
    icon: 'eyeopen',
    stylingMode: 'outlined',
    hint: 'İşlem Geçmişi',
    onClick: () => {
      this.showCrudHistory()
    },
  };

  infoButtonOptions: DxButtonTypes.Properties = {
    icon: 'help',
    hint: 'Uyarılar',
    stylingMode: 'outlined',
    onClick: () => {

    },

  };


  constructor(private utilsService: UtilsService,
  ) {
  }

  showLastErr(err: any) {
    this.utilsService.showError(err, '', 'toast-bottom-right')
  }

  showCrudHistory(){
    if(this.historyEntityName && this.historyEntityData){
      this.historyPopupVisible = true
    }

  }
  getFormName(page: any): string {
    return page?.slice(page?.lastIndexOf("/") + 1)
  }
}
